import { ReactComponent as AvatarIcon } from "logic/src/components/icons/logo.svg";
import AiContentTip from "logic/src/objects/session/components/AiContentTip";
import cls from "classnames";
import styles from "./index.module.scss";

const PopStatus = ({ text }: { text: string }) => {
  return (
    <div className={cls(styles.container)}>
      <AvatarIcon className={styles["avatar-icon"]} />

      <div className={styles.body}>
        <AiContentTip />
        <div className={styles.status}>{text}</div>
      </div>
    </div>
  );
};

export default PopStatus;
